import { render, staticRenderFns } from "./ligature_echo.vue?vue&type=template&id=28629d6f&scoped=true"
import script from "./ligature_echo.vue?vue&type=script&lang=js"
export * from "./ligature_echo.vue?vue&type=script&lang=js"
import style0 from "./ligature_echo.vue?vue&type=style&index=0&id=28629d6f&prod&scoped=true&lang=scss"
import style1 from "./ligature_echo.vue?vue&type=style&index=1&id=28629d6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28629d6f",
  null
  
)

export default component.exports